document.addEventListener("DOMContentLoaded", function() {
    var requested_service_detail_text = "";

    Array.from(document.querySelectorAll('.js-step:not(.current)')).forEach(function(el) {
        el.style.display = 'none';
    });

    document.addEventListener("click", function(e) {
        if(e.target && e.target.getAttribute("data-next-step")) {
            var validated = true;
            e.preventDefault();

            if (e.target.getAttribute("data-validate-step")) {
                validated = packetValidationStep(e.target.getAttribute("data-validate-step"));
            }

            if (validated) {
                clearPacketValidationErrors();

                var nextStep = e.target.getAttribute("data-next-step");

                if (nextStep == "diagnosis-step") {
                    document.querySelector('input[name="diagnosis"]').value = "Not Sure";
                    document.querySelector('input[name="effect"]').value = "Unknown";
                    requested_service_detail_text = "";
                }

                if (nextStep == "meso-step" && e.target.getAttribute("data-step-header")) {
                    document.querySelector('.js-meso-header').innerHTML = e.target.getAttribute("data-step-header");
                }

                if (nextStep == "customize-step" && e.target.getAttribute("data-back-button")) {
                    document.querySelector('.js-customize-back-button').setAttribute("data-next-step", e.target.getAttribute("data-back-button"));
                }
                nextLanderStep(nextStep);
            }
        }
    })

    function nextLanderStep(step) {
        Array.from(document.querySelectorAll(".js-step.current")).forEach(function(el) {
            el.style.display = 'none';
            el.classList.remove('current');
        });
        Array.from(document.querySelectorAll(".js-" + step)).forEach(function(el) {
            el.style.display = 'block';
            el.classList.add('current');
        });
    }

    function clearPacketValidationErrors() {
        Array.from(document.querySelectorAll(".has-error")).forEach(function(el) {
            el.classList.remove("has-error");
        });
    }

    function packetValidationStep(step) {
        if (step === "meso-step") {
            var mesoInputs = document.querySelectorAll('.js-meso-step input');
            for (var i = 0; i < mesoInputs.length; i++) {
                if (mesoInputs[i].checked) {
                    document.querySelector('input[name="diagnosis"]').value = document.querySelector('input[name="diagnosis_radio"]:checked').value;
                    document.querySelector('input[name="effect"]').value = "Mesothelioma";
                    return true;
                }
            }
            document.querySelector('.js-meso-step .js-formGroup').classList.add("has-error");
            document.querySelector('.js-meso-step .js-errorMessage').innerHTML = "Please select a diagnosis";
            return false;
        }
        if (step === "effect-step") {
            var effectInputs = document.querySelectorAll('.js-effect-step input');
            for (var i = 0; i < effectInputs.length; i++) {
                if (effectInputs[i].checked) {
                    requested_service_detail_text = document.querySelector('input[name="requested_service_detail_radio"]:checked').value + ", ";
                    return true;
                }
            }
            document.querySelector('.js-effect-step .js-formGroup').classList.add("has-error");
            document.querySelector('.js-effect-step .js-errorMessage').innerHTML = "Please select an option";
            return false;
        }
        if (step === "customize-step") {
            var customizeInputs = document.querySelectorAll('.js-customize-step input');
            var checkedOptions = [];
            for (var i = 0; i < customizeInputs.length; i++) {
                if (customizeInputs[i].checked) {
                    checkedOptions.push(customizeInputs[i].value);
                }
            }
            if (checkedOptions.length > 0) {
                document.querySelector('input[name="requested_service_detail"]').value = requested_service_detail_text + checkedOptions.join(", ");
                return true;
            } else {
                document.querySelector('.js-customize-step .js-formGroup').classList.add("has-error");
                document.querySelector('.js-customize-step .js-errorMessage').innerHTML = "Please select all that apply";
                return false;
            }
        }
    }

    document.addEventListener('change', function(e) {
        if (e.target.matches('.js-meso-step input, .js-effect-step input, .js-customize-step input')) {
            // remove any errors labels if found
            clearPacketValidationErrors();
        }
    });
    
    // Validation of radio options
    function validateCustomPacketRadios() {
        clearValidationErrors();
    
        // If no radio has been selected the var checkedRadios will return false
        var radios = document.querySelectorAll('.js-modal-radio');
        for (var i = 0; i < radios.length; i++) {
            if (radios[i].checked) {
                // A radio was found
                return true;
            }
        }
    
        // No radio button has been selected so update the dom to let the user know
        return false;
    }
    
    

});